const sensorAssignments = {
  // الاسم الظاهر في القائمة الجانبية وفق التصميم الحالي؛ نصوص كتالوج
  // الصلاحيات أدناه تبقى كما هي لأن الصلاحية نفسها لم تتغير.
  moduleTitle: "تعيين الأجهزة",
  nav: {
    sensorsManagement: "تعيين الحساسات",
  },
  actions: {
    view: "عرض",
    create: "إنشاء",
    update: "تعديل",
    delete: "حذف",
  },
  permissions: {
    core: "النواة",
    sensorAssignmentManagement: "إدارة تعيينات المستشعرات",
    sensorAssignments: "تعيينات المستشعرات",
  },
  sensor: {
    types: {
      WEIGHT: "وزن",
      TEMPERATURE: "حرارة",
      DOOR_STATUS: "حالة الباب",
      IBUTTON: "آي بوتون",
      PTO: "PTO",
      SEAT_BELT: "حزام الأمان",
      REFRIGERATOR_STATE: "حالة التبريد",
      HEADLIGHTS: "الأضواء الأمامية",
      SOS: "استغاثة (SOS)",
      RFID: "RFID",
    },
    configType: {
      NONE: "رقم الإدخال/الإخراج",
      SUM: "معادلة الجمع",
      PERCENT: "معادلة النسبة المئوية",
    },
    list: {
      title: "تعيين الحساسات",
      subtitle:
        "ربط الحساسات بالأجهزة ومتابعة حالة التنبيهات لكل جهاز في الأسطول.",
      toolbar: {
        search: "بحث في تعيينات الحساسات",
        searchPlaceholder: "بحث...",
        add: "تعيين حساس",
      },
      table: {
        name: "الاسم",
        sensorType: "الفئة",
        type: "النوع",
        minValue: "الحد الأدنى للوزن",
        maxValue: "الحد الأقصى للوزن",
        unit: "وحدة القياس",
        assignedDevice: "الجهاز المرتبط (IMEI)",
        company: "الشركة",
        createdDate: "تاريخ الإنشاء",
        actionMenu: "الإجراءات",
        empty: "لا توجد تعيينات حساسات.",
        error: "تعذر تحميل تعيينات الحساسات.",
        loading: "جارٍ تحميل تعيينات الحساسات",
        showing: "عرض {{count}} من {{total}}",
        rowsPerPageLabel: "عدد الصفوف في الصفحة",
        nextPage: "الصفحة التالية",
        previousPage: "الصفحة السابقة",
        pagination: "عرض الصفوف",
        sortAscending: "فرز تصاعدي",
        sortDescending: "فرز تنازلي",
      },
      filters: {
        filters: "الفلاتر",
        createdDate: "تاريخ الإنشاء",
        createdDatePlaceholder: "اختر نطاق تاريخ",
        clearDateRange: "مسح",
        nextMonth: "الشهر التالي",
        previousMonth: "الشهر السابق",
      },
      actions: {
        view: "عرض",
        update: "تعديل",
        delete: "حذف",
      },
      deleteDialog: {
        title: "حذف",
        question: "هل أنت متأكد أنك تريد حذف هذا الحساس؟",
        warning: "هذا الإجراء دائم ولا يمكن التراجع عنه.",
        confirmWord: "حذف",
        instruction: 'اكتب "{{word}}" لتأكيد الحذف',
        inputLabel: "تأكيد الحذف",
        confirm: "حذف",
        cancel: "إلغاء",
        close: "إغلاق نافذة الحذف",
        successFallback: "تمت إزالة تعيين الحساس بنجاح.",
      },
    },
    detail: {
      loading: "جارٍ تحميل إعدادات الحساس",
      loadError: "تعذر تحميل إعدادات هذا الحساس.",
      empty: "تعذر العثور على هذا الحساس.",
      configNotAvailable: "تفاصيل هذا النوع من الحساسات غير متاحة بعد.",
      backToList: "العودة إلى تعيينات الحساسات",
      subtitle: "التفاصيل والمعلومات الاساسية",
    },
    form: {
      title: "تعيين حساس",
      next: "التالي",
      back: "رجوع",
      save: "حفظ",
      cancel: "إلغاء",
      typeNotAvailable: "نوع الحساس هذا غير متاح بعد.",
      typeNotAvailableHint: "دعم نوع الحساس هذا قادم في تحديث لاحق.",
      stepOne: {
        subtitle: "اختر الشركة، ونوع الحساس، والجهة المستهدفة.",
        company: "الشركة",
        companyPlaceholder: "اختر شركة",
        companySearch: "بحث عن شركة",
        companyEmpty: "لا توجد شركات",
        sensorType: "نوع الحساس",
        sensorTypePlaceholder: "اختر نوع الحساس",
        configurationType: "نوع الإعداد",
        configurationTypeNew: "إعداد التهيئة",
        configurationTypeCopy: "نسخ التهيئة",
        sourceCompany: "جهة المصدر",
        sourceCompanyPlaceholder: "اختر شركة",
        copyFromDevice: "نسخ الاعدادات من جهاز",
        copyFromDevicePlaceholder: "رقم IMEI",
        copyPickSensorTypeFirst: "اختر نوع الحساس أولاً.",
        copyNoMatchingSensor: "لا يوجد حساس {{sensorType}} مُعد على هذا الجهاز.",
        copyConfigUnavailable: "لا يمكن نسخ إعداد هذا الجهاز حالياً.",
        copyDeviceRequired: "اختر جهازاً لنسخ الإعداد منه.",
        targetDeviceSearch: "بحث برقم IMEI",
        targetDeviceEmpty: "لا توجد أجهزة",
        targetSection: "الجهة المستهدفة",
        targetType: "نوع الجهة",
        targetTypeAll: "الكل",
        targetTypeBranch: "فروع",
        targetTypeDevices: "جهاز أو اكثر",
        targetDestination: "الجهة المنقول اليها",
        targetTypeAllCount: "الكل ({{count}})",
        targetBranchPlaceholder: "اختر فرعاً",
        targetBranchEmpty: "لا توجد فروع",
        targetBranchRequired: "اختر فرعاً.",
        targetDevicesPlaceholder: "اختر أجهزة",
        targetDevicesRequired: "اختر جهازاً واحداً على الأقل.",
        targetDeviceAlreadyAssigned: "هذا الحساس معيّن بالفعل للجهاز المحدد.",
        removeTargetDevice: "إزالة {{imei}}",
        targetResolveFailed: "تعذر تحميل الأجهزة لهذه الجهة. حاول مرة أخرى.",
        targetNoDevicesFound: "لا توجد أجهزة لهذه الجهة.",
      },
      weight: {
        title: "أعدادات الحساس - الوزن",
        subtitle: "أضف قراءة إدخال/إخراج واحدة أو أكثر، ثم ادمجها عند الحاجة.",
        unit: "وحدة القياس",
        addIo: "الادخال / الاخراج (I/O)",
        addFormula: "معادله",
        addSum: "معادله المجموع",
        addPercent: "معادله النسبه المئويه",
        ioSectionLabel: "الادخال / الاخراج (I/O)",
        io: "رقم الإدخال/الإخراج (IO)",
        ioPlaceholder: "مثال: 9",
        label: "الأسم",
        minWeight: "الحد الأدنى للوزن (كجم)",
        maxWeight: "الحد الأقصى للوزن (كجم)",
        millivolt: "مللي فولت",
        kilograms: "كجم",
        percentage: "نسبه الوزن",
        addCalibrationPoint: "اضافه",
        removeCalibrationPoint: "إزالة نقطة المعايرة {{number}}",
        calibrationEcuHint:
          "اترك جدول المعايرة فارغًا لمستشعرات الوزن التي يتم حسابها بواسطة وحدة التحكم الإلكترونية (ECU).",
        calibrationRangeHint:
          "يجب أن تبدأ قيمة الكيلوجرام المعايرة عند الحد الأدنى للوزن وتنتهي عند الحد الأقصى للوزن.",
        removeRow: "إزالة",
        editRow: "تعديل",
        ioDialogTitle: "تهيئة الإدخال/الإخراج",
        ioDialogSubtitle: "تفاصيل IO",
        ioDialogMainTab: "الرئيسية",
        ioDialogCalibrationTab: "المعايرة",
        formulaDialogTitle: "إعدادات المعادلة",
        formulaDialogSubtitle: "تفاصيل المعادله",
        selectIoLabel: "اختر الإدخال/الإخراج (IO)",
        dialogClose: "إغلاق",
        dialogSave: "حفظ",
        formulaCard: {
          editFormula: "تعديل",
          deleteFormula: "حذف",
          table: {
            name: "الأسم",
            type: "نوع المعادله",
            percentage: "النسبه",
            percentageChart: "مخطط النسبه",
          },
        },
        formulaClearedOnRowRemoved:
          "تم حذف المعادلة لأن أحد المدخلات/المخرجات التي تجمعها أُزيل. أضفها من جديد إذا احتجت إليها.",
        clearFormulaDialog: {
          title: "مسح المعادلة الحالية؟",
          description:
            "سيؤدي هذا إلى مسح {{formulaType}} الحالية. ستبقى قراءات الإدخال/الإخراج، ولكن كقراءات مستقلة غير مجمّعة. لا يمكن التراجع عن هذا الإجراء.",
          confirm: "مسح المعادلة",
          close: "إغلاق",
        },
        switchFormulaTypeDialog: {
          title: "تبديل نوع المعادلة؟",
          description:
            "سيؤدي التبديل إلى مسح البيانات التي أدخلتها لهذه المعادلة. لا يمكن التراجع عن هذا الإجراء.",
          confirm: "تبديل",
          close: "إغلاق",
        },
        table: {
          label: "الاسم",
          io: "رقم الإدخال/الإخراج",
          minWeight: "الحد الأدنى للوزن (كجم)",
          maxWeight: "الحد الأقصى للوزن (كجم)",
          calibration: "المعايرة",
          unit: "وحدة القياس",
          empty: "لا توجد بيانات لعرضها أو لا توجد سجلات.",
          ecu: "ECU",
          calibrationPoints: "{{count}} نقطة",
          calibrationPoints_other: "{{count}} نقاط",
        },
        validation: {
          required: "هذا الحقل مطلوب.",
          ioRange: "أدخل رقماً صحيحاً بين 0 و65535.",
          ioDuplicate: "رقم الإدخال/الإخراج هذا مستخدم بالفعل في هذا الإعداد.",
          maxWeight: "يجب أن يكون الحد الأقصى للوزن أكبر من الحد الأدنى.",
          labelTooLong: "يجب ألا يزيد عن {{count}} حرفاً.",
          calibrationMinPoints: "أضف نقطة معايرة أخرى على الأقل، أو احذفها.",
          calibrationDistinctMv: "يجب أن تكون قيم المللي فولت في المعايرة مختلفة.",
          atLeastOneIo: "أضف قراءة إدخال/إخراج واحدة على الأقل قبل الحفظ.",
          percentageTotal:
            "يجب أن يساوي إجمالي النسبة المئوية للوزن لجميع مستشعرات الوزن 100%.",
        },
        ioConflict:
          "هذا الحساس معيّن بالفعل للجهاز المحدد (مدخل/مخرج {{ios}}).",
        saveSuccess: "تم تعيين الحساس بنجاح.",
        updateSuccess: "تم تحديث الحساس بنجاح.",
        saveFailed: "تعذر حفظ إعداد الحساس.",
      },
      temperature: {
        title: "أعدادات الحساس - درجه الحراره",
        subtitle: "أضف حساساً واحداً أو أكثر.",
        label: "الاسم",
        probeType: "نوع الحساس",
        temperatureIo: "رقم إدخال/إخراج درجة الحرارة",
        temperatureUnit: "رمز وحدة درجة الحرارة",
        humidityIo: "رقم إدخال/إخراج الرطوبة",
        humidityUnit: "رمز وحدة الرطوبة",
        batteryIo: "رقم إدخال/إخراج البطارية",
        batteryUnit: "رمز وحدة البطارية",
        dallasIo: "رقم إدخال/إخراج DALLAS-ID",
        beaconModel: "معامل الضرب",
        beaconModels: {
          TZONE_BT04: "0.1 (Tzone BLE BT04)",
          MINEW_MST01: "1 (Minew MST01)",
        },
        table: {
          probeType: "نوع الحساس",
          label: "اسم الحساس",
          temperatureIo: "مدخل درجة الحرارة",
          humidityIo: "مدخل الرطوبة",
          batteryIo: "مدخل البطارية",
          dallasIo: "مدخل Dallas",
          empty: "لا توجد حساسات مضافة بعد.",
        },
        validation: {
          atLeastOneIo: "أضف حساساً واحداً على الأقل قبل الحفظ.",
        },
      },
      simpleIo: {
        title: "أعدادات الحساس - {{type}}",
        subtitle: "أضف قراءة إدخال/إخراج واحدة أو أكثر.",
      },
      rfid: {
        title: "أعدادات الحساس - RFID",
        subtitle: "أضف قراءة إدخال/إخراج واحدة أو أكثر مع طول علامة التحقق الخاصة بها.",
        tagLength: "طول علامة التحقق",
        tagLengthPlaceholder: "مثال: 2",
        validation: {
          tagLengthRange: "أدخل رقماً صحيحاً بين 1 و64.",
        },
      },
      valueMap: {
        title: "أعدادات الحساس - {{type}}",
        rowLabel: "الاسم",
        value: "القيمة",
        labelEn: "الاسم (بالإنجليزية)",
        labelAr: "الاسم (بالعربية)",
        table: {
          values: "القيم",
          empty: "لم تتم إضافة أي قراءات بعد.",
        },
        validation: {
          valuesDuplicate: "يجب أن تكون القيمتان مختلفتين.",
        },
      },
    },
  },
};

export default sensorAssignments;
